import React, {useEffect, useState} from "react"

export default function StatusTag(props) {  

const [color, setColor] = useState("");

useEffect(() => {
    switch(props.status) {
        case "Active": return setColor("ta7");
        case "Close Requested":
        case "Rejected": return setColor("tb8");
        case "Pending": return setColor("y8");
        case "Closed": return setColor("pu8");
        default: return setColor("g8");
        // case "Active": color !== "ta7" && setColor("ta7");
        // case "Close Requested":
        // case "Rejected": color !== "tb9" && setColor("tb9");
        // default: color !== "g8" && setColor("g8");
    }
}, [props.status]);
    
const fontSize = props.fontSize ? " " + props.fontSize : " content3";  

const lineHeight = props.lineHeight ? props.lineHeight : "200%"

    return (
            <p style={{lineHeight: `${lineHeight}`}} className={"doc-status-tag light-black " + color + fontSize }>{props.status}</p>
        
    )
}
